// Site-wide search service
// Searches across books, surahs, videos, and other content

import { quranApi } from './quranApiService'
import { libraryApi } from './libraryApiService'
import { videosApi } from './videosApiService'

export interface SearchResult {
  id: string
  type: 'book' | 'surah' | 'video' | 'library'
  title: string
  description?: string
  url: string
  category?: string
}

export const searchSite = async (query: string): Promise<SearchResult[]> => {
  if (!query || query.trim().length < 2) {
    return []
  }

  const normalizedQuery = query.toLowerCase().trim()
  const results: SearchResult[] = []

  try {
    // Search surahs
    const surahs = await quranApi.getSurahs(query)
    surahs.forEach((surah) => {
      results.push({
        id: `surah-${surah.number}`,
        type: 'surah',
        title: surah.name,
        description: `سورة ${surah.nameEn}`,
        url: `/quran/${surah.number}`,
        category: 'القرآن الكريم',
      })
    })
  } catch (error) {
    console.error('Error searching surahs:', error)
  }

  try {
    // Search books
    const books = await libraryApi.getBooks(undefined, query)
    books.forEach((book) => {
      results.push({
        id: `book-${book.id}`,
        type: 'book',
        title: book.title,
        description: book.description || book.author,
        url: `/library/${book.id}`,
        category: book.categoryName,
      })
    })
  } catch (error) {
    console.error('Error searching books:', error)
  }

  try {
    // Search videos
    const videos = await videosApi.getVideos(undefined, query)
    videos.forEach((video) => {
      results.push({
        id: `video-${video.id}`,
        type: 'video',
        title: video.title,
        description: video.description,
        url: `/videos/${video.id}`,
        category: 'الفيديوهات',
      })
    })
  } catch (error) {
    console.error('Error searching videos:', error)
  }

  // Sort by relevance (title matches first)
  return results.sort((a, b) => {
    const aTitleMatch = a.title.toLowerCase().includes(normalizedQuery)
    const bTitleMatch = b.title.toLowerCase().includes(normalizedQuery)
    if (aTitleMatch && !bTitleMatch) return -1
    if (!aTitleMatch && bTitleMatch) return 1
    return 0
  })
}


